import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../i18n";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { StatusBadge } from "../../components/app/widgets";
import { Input } from "../../components/ui/input";

export default function CasesList() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const nav = useNavigate();
  const [cases, setCases] = useState([]);
  const [q, setQ] = useState("");
  const isStaff = !["client_admin", "client_user"].includes(user.role);

  useEffect(() => { api.get("/cases").then((r) => setCases(r.data)).catch(() => {}); }, []);

  const filtered = cases.filter((c) => !q || c.reference.toLowerCase().includes(q.toLowerCase()) || (c.organization_name || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5 gc-fade-up">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{isStaff ? t("nav_queue") : t("nav_cases")}</h1>
        <Input data-testid="cases-search" placeholder="🔍" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" />
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs">
            <tr>
              <th className="text-start px-4 py-3 font-medium">{t("reference")}</th>
              {isStaff && <th className="text-start px-4 py-3 font-medium hidden sm:table-cell">{t("nav_clients")}</th>}
              <th className="text-start px-4 py-3 font-medium">{t("service")}</th>
              <th className="text-start px-4 py-3 font-medium hidden md:table-cell">{t("assigned")}</th>
              <th className="text-start px-4 py-3 font-medium">{t("status")}</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">{t("no_cases")}</td></tr>}
            {filtered.map((c) => (
              <tr key={c.id} data-testid={`case-row-${c.id}`} onClick={() => nav(`/app/cases/${c.id}`)}
                className="border-t border-border hover:bg-secondary/40 cursor-pointer">
                <td className="px-4 py-3 font-mono text-xs text-[hsl(217_63%_15%)] font-medium">{c.reference}</td>
                {isStaff && <td className="px-4 py-3 hidden sm:table-cell">{c.organization_name}</td>}
                <td className="px-4 py-3">{lang === "ar" ? c.service_label_ar : c.service_label_en}</td>
                <td className="px-4 py-3 hidden md:table-cell text-muted-foreground">{c.assigned_specialist_name || "—"}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
